import useSWR from 'swr';

import { BillOfMaterials } from 'models';

import { prepareConditionalSwrArgs } from 'hooks/prepare-conditional-swr-args';
import { useCurrentDesign } from 'hooks/use-current-design';
import { useCurrentProject } from 'hooks/use-current-project';
import { BillOfMaterialsService } from 'services/BillOfMaterialsService';

const useBillOfMaterials = () => {
    const project = useCurrentProject();
    const design = useCurrentDesign();

    const designId = design?.id;

    const swr = useSWR(
        ...prepareConditionalSwrArgs({
            key: `/api/billOfMaterials/get-by-design/${designId}`,
            fetcher: () => BillOfMaterialsService.getByDesign(designId!),
            condition: Boolean(designId) && !!project,
        }),
        {
            revalidateOnFocus: false,
            revalidateIfStale: true,
        },
    );

    const billOfMaterials = (swr.data?.doc ?? {}) as BillOfMaterials;

    return {
        ...swr,
        isValidating: !swr.isLoading && swr.isValidating,
        billOfMaterials,
    };
};

export { useBillOfMaterials };
